import { render, staticRenderFns } from "./CardLayout.vue?vue&type=template&id=63263b77&scoped=true&"
import script from "./CardLayout.vue?vue&type=script&lang=js&"
export * from "./CardLayout.vue?vue&type=script&lang=js&"
import style0 from "./CardLayout.vue?vue&type=style&index=0&id=63263b77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63263b77",
  null
  
)

export default component.exports